import React from 'react';
// template components
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// images
import financialPlanningImageWebp from './images/business-people-reviewing-paperwork.webp';

export default () => {
  return (
    <InformationalModule
      sectionId='financial-information-financial-planning-2'
      moduleName='financial-planning-module'
      moduleVariant='A'
      backgroundVariant='lightB'
      themeType='lightTheme'
      reverseContent
      // column content
      headingAssistiveText='Automatic protection'
      columnContentA={(
        <>
          <Typography nextElement='typography'>
            Trust is the foundation of all successful financial relationships. You need the confidence that we know what we&#39;re doing, will honor our commitments, and that you&#8212;our client&#8212;are our highest priority. To do these things all of the time&#8212;free from the pressure to cut corners or from being distracted by financial pressures&#8212;means having the resources that only come with financial strength.
          </Typography>
          <Typography
            nextElement='typography'
            component='h3'>
            Our investment accounts come with automatic protection.
          </Typography>
          <Typography nextElement='link'>
            While Northwestern Mutual is one of the strongest companies in America, we also have automatic protection in place for our investments. That&#39;s because Northwestern Mutual Investment Services, LLC &#40;NMIS&#41; is a member of Securities Investor Protection Corporation &#40;SIPC&#41;. SIPC protects NMIS accounts up to &#36;500,000 &#40;including &#36;250,000 for claims for cash&#41; in the event that a firm fails.
          </Typography>
          <Link
            linkUrl='/investments/protection/'
            variant='primaryDeemphasize'
            endAdornment={CaratRight}
            endAdornmentStylesReset>
            Find out more
          </Link>
        </>
      )}
      // image props
      imageAltText='Business people reviewing some paperwork'
      imageSrcDefault={financialPlanningImageWebp.toString()}
    />
  );
};
